import axios from 'axios';
import { config } from 'shared/config';
import { configureAuthenticatedClient } from './session';

export function createReportTransport(basePath: string) {
  const client = axios.create({ baseURL: config.API_URL + basePath, timeout: 120000 });
  configureAuthenticatedClient(client);
  return { client, api: {
  get: async <T,>(path: string, options?: {signal?: AbortSignal}): Promise<T> =>
    (await (options ? client.get<T>(path, options) : client.get<T>(path))).data,
  post: async <T,>(path: string, payload: unknown): Promise<T> => (await client.post<T>(path, payload)).data,
  remove: async (path: string): Promise<void> => { await client.delete(path, { data: {} }); },
  bytes: async (path: string): Promise<Blob> => {
    try { return (await client.get<Blob>(path, {responseType:'blob'})).data; }
    catch (error:any) {
      if (error.response?.data instanceof Blob) {
        try { error.response.data = JSON.parse(await error.response.data.text()); } catch { /* Preserve the transport error. */ }
      }
      throw error;
    }
  },
  } };
}
export const reportPath = (id: string) => '/reports/' + id;
export const errorText = (error: any): string => error?.response?.data?.error || error?.message || 'Something went wrong. Please retry.';
